import { Button, Modal, Tooltip } from 'antd';
import { useWorkorderDetailContext } from '../WorkorderDetailProvider';
import BoschCoReReport from './BoschCoReReport';
import { useBoschJobCardCreate } from '@/core/domain/workorder/Bosch/Bosch.hooks';
import { useMatrix } from '@/core/domain/enterprise/Matrix/Matrix.hooks';
import { MatrixPartnerOrigin } from '@/types/Register';

export default function BoschCoRe() {
  const {
    workorder: { data: workOrder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const hasBoschCoreAccess = !!workOrder?.boschCoreAccess;
  const hasVehicle = !!workOrder?.vehicle?.licensePlate;

  const boschJobCardCreate = useBoschJobCardCreate();
  const { data: matrix } = useMatrix();

  const partnerEnabled =
    !!matrix?.partnerOrigin &&
    [
      MatrixPartnerOrigin.BOSCH_CAR_SERVICE,
      MatrixPartnerOrigin.BOSCH_MODULO,
    ].includes(matrix?.partnerOrigin);

  const createJobCoRe = async () => {
    try {
      if (!complement?.id) return;

      await boschJobCardCreate.mutateAsync(complement.id);
    } catch {}
  };

  const confirmGenerateDiagnostic = () => {
    Modal.confirm({
      title: 'Gerar Diagnostico Bosch CoRe',
      content: (
        <>
          <span>
            Gostaria de continuar e gerar um diagnostico integrado ao CoRe da
            Bosch para o veículo{' '}
            <strong>{`"${workOrder?.vehicle?.licensePlate} - ${workOrder?.vehicle?.brand} - ${workOrder?.vehicle?.model}"`}</strong>
            ?
          </span>
        </>
      ),
      okText: 'Gerar',
      onOk: createJobCoRe,
    });
  };

  if (!hasBoschCoreAccess || !partnerEnabled) return null;

  if (!complement?.hasJobCard) {
    return (
      <Tooltip title={!hasVehicle ? 'Selecione um veículo' : undefined}>
        <Button
          onClick={confirmGenerateDiagnostic}
          type="primary"
          className="btn-bosch"
          disabled={!hasVehicle}
        >
          Diagnóstico Bosch CoRe
        </Button>
      </Tooltip>
    );
  }

  return <BoschCoReReport />;
}
